import { useTranslation } from 'react-i18next';
import SearchableSelect from '../../searchableSelect/searchableSelect';
import { useSkillSelect } from './useSkillSelect';

interface SkillSelectProps {
  disabled: boolean;
  onOpenPicker: () => void;
  onClear?: () => void;
}

/**
 * Its own component so the skill list is only fetched where the field is rendered. It renders the
 * trigger button directly, which lookup siblings like `LookupClearButton` rely on.
 */
const SkillSelect = ({ disabled, onOpenPicker, onClear }: Readonly<SkillSelectProps>) => {
  const { t } = useTranslation();
  const select = useSkillSelect();

  return (
    <SearchableSelect
      {...select}
      disabled={disabled}
      ariaLabel={t('transaction:requiredSkill')}
      placeholder={t('transaction:selectSkill')}
      searchPlaceholder={t('transaction:searchSkills')}
      onSearchIconClick={onOpenPicker}
      onClear={onClear}
      data-field="skill"
      data-testid="add-skill-button"
    />
  );
};

export default SkillSelect;
